import { render, staticRenderFns } from "./GdprRadio.vue?vue&type=template&id=0e872f8a&scoped=true&"
import script from "./GdprRadio.vue?vue&type=script&lang=js&"
export * from "./GdprRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e872f8a",
  null
  
)

export default component.exports